import { render, staticRenderFns } from "./guide-book-papers.vue?vue&type=template&id=1d6eb9ba"
import script from "./guide-book-papers.vue?vue&type=script&lang=js"
export * from "./guide-book-papers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports